module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAARRJREFUOBHdUztOw0AQfbOk2RjKVHSIBik1EoiCQ1ByAgqOQMNRgCsEKspU6SJxgJzAkj+LFezhbeRBViJjlBIXOzM7897MPo0lK8o5VC+wxyeCmWR5oXtgDZKOzPvNisga0CeILFmnqrjheRUxgwQE105wPR4nc2uSl+UxSf5GwIavBs6qaoq6nrL7mZENTsCxP6wY6693+pOuaO4n2ePwwVVM0QrNZLusdwKBPONA3uBcFI6DiOYh3G4IGr0n4Xn0ewngsDj0/mUDaA+LuTt3dt9P0OAkhBCVXnnvVxHQxtSxOTUdhhdJ8HiUJA9Rg7woG+vc2nRQxC3ATvgPCEbxl+ReX+48rr1wcJ+dXNrxwV2ZfQNffWL6VDBoKgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/layouts/PageLayout/assets/Facebook.png
// module id = ./src/layouts/PageLayout/assets/Facebook.png
// module chunks = 1